"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavSidepanel = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _molecules = require("../../molecules");

var _atoms = require("../../atoms");

var _DashboardPanel = require("../DashboardPanel");

var _GamesList = require("../GamesList");

require("./NavSidepanel.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Sorted Teams
var SortedTeams = function SortedTeams(_ref) {
  var divisions = _ref.divisions;

  var sortedDivisions = _toConsumableArray(divisions ? divisions : []).sort(function (a, b) {
    return a.title.localeCompare(b.title);
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, sortedDivisions.map(function (division, index) {
    var sortedTeams = division !== null && division !== void 0 && division.teams ? _toConsumableArray(division.teams).sort(function (a, b) {
      var _a$title, _b$title;

      return ((_a$title = a.title) === null || _a$title === void 0 ? void 0 : _a$title.toLowerCase()) < ((_b$title = b.title) === null || _b$title === void 0 ? void 0 : _b$title.toLowerCase()) ? -1 : 1;
    }) : [];
    return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      key: "".concat(division.division_id, "-").concat(index)
    }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      className: "divider"
    }), /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
      key: "navdropdown-division-".concat(division.title),
      title: division.title,
      headerLinkTitle: division.is_member ? "Settings" : "",
      headerLink: division.is_member ? "/#/".concat(division.teams[0].name, "/settings/division/").concat(division.division_id) : null
    }, sortedTeams.map(function (team) {
      return /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
        trkAction: "Team Link Pressed",
        key: "navdropdown-divisions-team-".concat(team.name),
        href: "".concat(process.env.REACT_APP_GO_TRACEUP, "/#/").concat(team.name),
        title: team.title
      });
    })));
  }));
}; // Nav Sidepanel


var NavSidepanel = function NavSidepanel(_ref2) {
  var user = _ref2.user,
      onClose = _ref2.onClose,
      allTeams = _ref2.allTeams,
      divisions = _ref2.divisions,
      maxHeight = _ref2.maxHeight,
      traceIdURL = _ref2.traceIdURL,
      recentGames = _ref2.recentGames,
      shouldShowDivisionsSeparately = _ref2.shouldShowDivisionsSeparately,
      utm_source = _ref2.utm_source,
      utm_medium = _ref2.utm_medium,
      utm_campaign = _ref2.utm_campaign,
      handleSignIn = _ref2.handleSignIn,
      accountManagementChildren = _ref2.accountManagementChildren,
      externalTeam = _ref2.externalTeam;
  var cn = "HamburgerMenu";
  var history = (0, _reactRouter.useHistory)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var userId = user ? user.user_id : null;
  var userEmail = user ? user.email : null;

  var handleEsc = function handleEsc(e) {
    var el = document.querySelector(".HamburgerMenu.open");

    if (el && e.keyCode === 27 && onClose && typeof onClose === "function") {
      onClose(true);
    }
  };

  (0, _react.useEffect)(function () {
    // close panel on location change
    var unlisten = history.listen(function () {
      if (isOpen) setIsOpen(false);
    }); // stop the listener when component unmounts

    return unlisten;
  });
  (0, _react.useEffect)(function () {
    document.addEventListener("keyup", handleEsc);
    return function () {
      document.removeEventListener("keypress", handleEsc);
    };
  }, [handleEsc]);

  var handleShouldClose = function handleShouldClose() {
    setIsOpen(false);

    if (typeof onClose === "function") {
      onClose(true);
    }
  };

  cn += isOpen ? " open" : " closed";
  var referLink = "https://traceup.com/refer?utm_source=".concat(utm_source, "&utm_medium=").concat(utm_medium, "&utm_campaign=").concat(utm_campaign);
  if (userEmail) referLink += "&referred_by=".concat(userEmail);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
    trkAction: "NavDropdown Pressed",
    className: "hamburger-menu-icon",
    color: _atoms.Color.Transparent,
    backgroundColor: _atoms.Color.Transparent,
    iconColor: _atoms.Color.Grey3,
    iconSize: 24,
    icon: _atoms.Icon.Type.Menu,
    onClick: function onClick() {
      return setIsOpen(true);
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: cn,
    trkContext: "Hamburger Menu"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "Shade",
    onClick: function onClick() {
      return handleShouldClose();
    }
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "HamburgerMenuInner"
  }, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Close Menu",
    icon: _atoms.Icon.Type.Close,
    marginBottom: "6",
    onClick: function onClick() {
      return handleShouldClose();
    }
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "navdropdown-inner-content",
    style: {
      maxHeight: maxHeight
    }
  }, externalTeam && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
    classNames: "external-team",
    title: ""
  }, /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    handleClick: function handleClick() {
      return handleShouldClose();
    },
    trkAction: "Game Team Link Pressed",
    key: "navdropdown-".concat(externalTeam.name),
    icon: _atoms.Icon.Type.Games,
    href: "".concat(process.env.REACT_APP_GO_TRACEUP, "/#/").concat(externalTeam.name),
    title: externalTeam.title
  })), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "divider"
  })), /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
    classNames: "explore",
    title: "Explore"
  }, user && /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    handleClick: function handleClick() {
      return handleShouldClose();
    },
    trkAction: "My Trace iD Pressed",
    icon: _atoms.Icon.Type.Moment,
    href: "".concat(traceIdURL, "/find/user/").concat(userId),
    title: "My Trace iD"
  }), accountManagementChildren, user && !shouldShowDivisionsSeparately && (allTeams === null || allTeams === void 0 ? void 0 : allTeams.slice(0, 3).map(function (team) {
    return /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
      handleClick: function handleClick() {
        return handleShouldClose();
      },
      trkAction: "Team Link Pressed",
      key: "navdropdown-".concat(team.name),
      icon: _atoms.Icon.Type.Games,
      href: "".concat(process.env.REACT_APP_GO_TRACEUP, "/#/").concat(team.name),
      title: team.title
    });
  })), /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    handleClick: function handleClick() {
      return handleShouldClose();
    },
    trkAction: "Leaderboard Pressed",
    icon: _atoms.Icon.Type.Leaderboard,
    href: "/leader/boards/",
    title: "Leaderboards"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "divider"
  }), user && /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
    title: "Recent games",
    onClick: function onClick() {
      return handleShouldClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_GamesList.GamesList, {
    games: recentGames
  })), user && shouldShowDivisionsSeparately && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    onClick: function onClick() {
      return handleShouldClose();
    }
  }, /*#__PURE__*/_react.default.createElement(SortedTeams, {
    divisions: divisions
  })), !user && /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
    title: "More"
  }, /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    handleClick: function handleClick() {
      return handleShouldClose();
    },
    trkAction: "Academy Pressed",
    icon: _atoms.Icon.Type.Academy,
    href: "https://traceup.com/soccer/academy",
    title: "Academy"
  }), /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    handleClick: function handleClick() {
      return handleShouldClose();
    },
    trkAction: "Refer a Team Pressed",
    icon: _atoms.Icon.Type.Referral,
    href: referLink,
    title: "Refer a team. Get $100"
  }), /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    handleClick: function handleClick() {
      return handleShouldClose();
    },
    trkAction: "Help Pressed",
    icon: _atoms.Icon.Type.Question,
    href: "https://traceup.com/soccer/help",
    title: "Help"
  }), /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    trkAction: "Sign In Pressed",
    handleClick: function handleClick(e) {
      handleShouldClose();
      handleSignIn();
    },
    icon: _atoms.Icon.Type.SignIn,
    title: "Sign in"
  }))))));
};

exports.NavSidepanel = NavSidepanel;
NavSidepanel.defaultProps = {
  maxHeight: "none",
  utm_source: "go",
  utm_medium: "webapp",
  utm_campaign: "refs"
};